import PropTypes from 'prop-types'
import React from 'react'
import Job from 'import/dto/Job'
import { useState } from 'react'
import IAEauAction from '../../../../iaeau/IAEauAction'
import { useDispatch, useSelector } from 'react-redux'
import HydratecParamsPanel from '../../../../station/components/iaeauModels/modelParamsPanel/HydratecParamsPanel'
import i18n from 'simple-react-i18n'
import { Grid } from '@mui/material'
import RadioButtons from '../../../../components/forms/RadioButtons'

const IAEAU_ENV_PROD = 'prod'
const IAEAU_ENV_RECETTE = 'recette'

const ModelCalculJob = ({
    job = {},
    filters = {},
    isEditMode = false,
    onExecute = () => {},
    onChangeJob = () => {},
    onChangeFilters = () => {},
}) => {
    const dispatch = useDispatch()
    const [model, setModel] = useState(undefined)
    const accountUser = useSelector(store => store.AccountReducer.accountUser)
    const contacts = useSelector(store => store.ContactReducer.contacts)
    const userEmail = accountUser?.email || contacts?.find(c => c.id === accountUser?.contactCode)?.email || ''
    const isAquasysUser = userEmail.toLowerCase().includes('@aquasys.fr')
    const isHydratec = job?.name?.toLowerCase()?.includes('hydratec')

    if (isHydratec && !model) {
        dispatch(IAEauAction.getModels('hydrometry', 33)).then(res => {
            setModel(res.find(m => m.typeModel === 'HYDRATEC'))
        })
        return null
    }

    const iaeauEnvElements = [
        { code: IAEAU_ENV_PROD, label: i18n.iaeauEnvProd },
        { code: IAEAU_ENV_RECETTE, label: i18n.iaeauEnvRecette },
    ]

    return (
        <Grid container rowSpacing={1}>
            {isAquasysUser && (
                <Grid size={12}>
                    <RadioButtons
                        title={i18n.iaeauEnv}
                        elements={iaeauEnvElements}
                        selected={filters.iaeauEnv || IAEAU_ENV_PROD}
                        onChange={value => onChangeFilters({ iaeauEnv: value })}
                        disabled={!isEditMode}
                    />
                </Grid>
            )}
            {isHydratec && (
                <Grid size={12}>
                    <HydratecParamsPanel
                        id={33}
                        model={model}
                        onExecute={onExecute}
                        onChangeJob={onChangeJob}
                    />
                </Grid>
            )}
        </Grid>
    )
}

ModelCalculJob.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    filters: PropTypes.object,
    isEditMode: PropTypes.bool,
    onExecute: PropTypes.func,
    onChangeJob: PropTypes.func,
    onChangeFilters: PropTypes.func,
}

export default ModelCalculJob
